export default __webpack_public_path__ + "static/media/health_check_locked.b6403fcb.png";